import React, { useEffect, useRef } from "react";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { useDispatch, useSelector } from "react-redux";
import { SELECTED_FEATURES } from "../../../../components/views/TenantSignUp/tenantSignUpConstants";

const NO_LICENSE = "None";

function DataControlPlatformChanges({ tenantDetails }) {
  const dispatch = useDispatch();

  const selectedFeatures = useSelector(
    (state) => state.tenantSignUpReducer?.selectedFeatures || [],
  );

  const findFeatureId = (name) =>
    tenantDetails?.featuresData?.find((f) => f.name === name)?.id;

  const dataControlFeatureId = findFeatureId("Data Control");
  const dataVisionFeatureId = findFeatureId("Data Vision");

  const silverLicenseId = tenantDetails?.licenceTypeData?.find(
    (license) => license.name === "Silver",
  )?.id;

  const noneLicenseId = tenantDetails?.licenceTypeData?.find(
    (license) => license.name === "None",
  )?.id;

  const isLicensed = (licenseTypeId) =>
    !!licenseTypeId &&
    licenseTypeId !== NO_LICENSE &&
    licenseTypeId !== noneLicenseId;

  const entryFor = (featureId) =>
    selectedFeatures.find((f) => f.featureId === featureId);

  const dataControlEntry = entryFor(dataControlFeatureId);
  const dataVisionEntry = entryFor(dataVisionFeatureId);

  const dataVisionEnabled = isLicensed(dataVisionEntry?.licenseTypeId);
  const dataControlEnabled = isLicensed(dataControlEntry?.licenseTypeId);

  const setDataControlLicense = (licenseTypeId) => {
    if (!dataControlFeatureId) return;

    const updatedFeatures = dataControlEntry
      ? selectedFeatures.map((feature) =>
          feature.featureId === dataControlFeatureId
            ? { ...feature, licenseTypeId }
            : feature,
        )
      : [...selectedFeatures, { featureId: dataControlFeatureId, licenseTypeId }];

    dispatch({ type: SELECTED_FEATURES, payload: updatedFeatures });
  };

  const prevDataVisionEnabled = useRef(null);

  useEffect(() => {
    if (!dataControlFeatureId || !silverLicenseId) return;
    if (!selectedFeatures.length) return;

    const was = prevDataVisionEnabled.current;
    prevDataVisionEnabled.current = dataVisionEnabled;

    if (was === null) return;
    if (was === dataVisionEnabled) return;

    setDataControlLicense(dataVisionEnabled ? silverLicenseId : NO_LICENSE);
  }, [dataVisionEnabled, dataControlFeatureId, silverLicenseId, selectedFeatures]);

  useEffect(() => {
    if (!dataVisionEnabled && dataControlEnabled) {
      setDataControlLicense(NO_LICENSE);
    }
  }, [dataVisionEnabled, dataControlEnabled]);

  const handleToggle = (event) => {
    if (!dataVisionEnabled) return;
    setDataControlLicense(event.target.checked ? silverLicenseId : NO_LICENSE);
  };

  const disabled =
    !dataVisionEnabled || !dataControlFeatureId || !silverLicenseId;

  return (
    <div className="dataControlPlatform">
      <FormControlLabel
        classes={{ label: "dataControlLabel" }}
        control={
          <Switch
            checked={dataControlEnabled && dataVisionEnabled}
            onChange={handleToggle}
            color="primary"
            disabled={disabled}
          />
        }
        label="Data Control"
      />
      {!dataVisionEnabled && (
        <p className="dataControlHint">Requires Data Vision</p>
      )}
    </div>
  );
}

export default DataControlPlatformChanges;